module.exports = __webpack_public_path__ + "media/images/short_scenario_contest/sp-h1-title@2x-1dd9e79f7a8d2c057258d7bdc44ec823.png";